//=====================================================
//　フッター
//=====================================================

import { useContext } from "react";
import { Link } from "react-router-dom";
import { CtxClinicInfo } from "../../utils/Contexts";

export function Footer(){

    const cci = useContext(CtxClinicInfo);

    return (
        <footer>
            {cci.data.id && 
                <div className="footer-links">
                    {cci.data.tel &&
                        <a href={"tel:" + cci.data.tel} className="btn btn-tel"><span className="btn-tel-icon"></span>{cci.data.tel}</a>
                    }
                    <ul className="footer-link_list">
                        <li><Link to="/">TOP</Link></li>
                        <li><a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" >プライバシーポリシー</a></li>
                    </ul>
                </div>
            }
            <div className="footer-copyright text-s">
                Copyright © GENESIS inc. All Rights Reserved.
            </div>
        </footer>
    )
}